import {Component, OnDestroy, OnInit} from '@angular/core';
import {DataManagementService} from '../../services/data-management.service';
import {AccessService} from '../../services/access.service';
import {EpasUtilService} from '../../services/epas-util.service';
import {ActivatedRoute, Router} from '@angular/router';
import {Constants} from '../../constants';
import {ToastrService} from 'ngx-toastr';
import {Subject} from 'rxjs/Subject';
import {AppSettings} from '../../../app-settings';

@Component({
    selector: 'app-documents',
    templateUrl: './documents.component.html',
    styleUrls: ['./documents.component.css'],
    providers: [DataManagementService]
})
export class DocumentsComponent implements OnInit, OnDestroy {
    downloadStudentDocument = AppSettings.JAVA_API + AppSettings.DOWNLOAD_DOCUMENT;
    downloadIncomingStudentDocument = AppSettings.JAVA_API + AppSettings.DOWNLOAD_INCOMING_STUDENT_DOCUMENT;
    dtTrigger: Subject<string> = new Subject();
    dtOptions: DataTables.Settings = {};
    activeRoundLink: string;
    activeRound: string;
    route: string;
    timer;
    documentTypes;
    studentDocuments;
    incomingStudentDocuments;
    typeId;
    errorMessage: string = undefined;
    dataErrorMessage: string = undefined;
    selectUndefinedOptionValue = undefined;
    fileList: FileList;

    constructor(private accessService: AccessService,
                private utilService: EpasUtilService,
                private dmService: DataManagementService,
                private router: Router,
                private toastr: ToastrService) {
        this.router.events.subscribe(event => {
            this.route = this.router.url;
        });
    }

    getData() {
        const studentId = JSON.parse(localStorage.getItem('epas_user')).roles[0].epas_user_role_mapping.student_id;
        this.dmService.javaGetDataCallByParameter(Constants.GET_DOCUMENT_PAGE_DATE, studentId).subscribe(response => {
            if (response.status === 'success') {
                this.documentTypes = response.data.document_types;
                this.studentDocuments = response.data.student_documents;
                if ( this.documentTypes.length === 0 ) {
                    this.errorMessage = 'There are no document types available.';
                }
                if ( this.studentDocuments.length === 0 ) {
                    this.dataErrorMessage = 'There is no student documents available to display.';
                } else {
                    this.dtTrigger.next();
                }
            } else if (response.status === 'fail') {
                this.errorMessage = response.message;
                this.dataErrorMessage = response.message;
            }
        }, error => {
            console.log(error);
            this.errorMessage = 'Server Error';
            this.dataErrorMessage = 'Server Error';
        });
    }

    getIncomingStudentData() {
        const studentId = JSON.parse(localStorage.getItem('epas_user')).roles[0].epas_user_role_mapping.incoming_student_id;
        const userId = JSON.parse(localStorage.getItem('epas_user')).user_id;
        const parameter = studentId + '/' + userId;
        this.dmService.javaGetDataCallByParameter(Constants.GET_INCOMING_STUDENT_DOCUMENT_DATA, parameter)
            .subscribe(response => {
            if (response.status === 'success') {
                this.documentTypes = response.data.document_types;
                this.incomingStudentDocuments = response.data.student_documents;
                if ( this.documentTypes.length === 0 ) {
                    this.errorMessage = 'There are no document types available.';
                }
                if ( this.incomingStudentDocuments.length === 0 ) {
                    this.dataErrorMessage = 'There is no student documents available to display.';
                } else {
                    this.dtTrigger.next();
                }
            } else if (response.status === 'fail') {
                this.errorMessage = response.message;
                this.dataErrorMessage = response.message;
            }
        }, error => {
            console.log(error);
            this.errorMessage = 'Server Error';
            this.dataErrorMessage = 'Server Error';
        });
    }

    canAccessOIA() {
        return this.accessService.canAccessOIA();
    }

    canAccessOutgoingStudent() {
        return this.accessService.canAccessOutgoingStudent();
    }

    canAccessPOC() {
        return this.accessService.canAccessPOC();
    }

    canAccessIncomingStudent() {
        return this.accessService.canAccessIncomingStudent();
    }

    fileChange(event) {
        if (event.target.files.length !== 1) {
            throw new Error('Cannot upload multiple files on the entry');
        }
        this.fileList = event.target.files;
    }

    uploadFile() {
        if (this.typeId === null || this.typeId === undefined || this.typeId === '') {
            this.toastr.warning('Please select a valid document type', 'Fail');
            return;
        }
        if (this.fileList.length === 1) {
            const studentId = JSON.parse(localStorage.getItem('epas_user')).roles[0].epas_user_role_mapping.student_id;
            const termId = JSON.parse(localStorage.getItem('epas_user')).term.outgoing_term_id;
            const userId = JSON.parse(localStorage.getItem('epas_user')).user_id;
            const file: File = this.fileList[0];
            const formData: FormData = new FormData();
            formData.append('file', file);
            formData.append('document_type_id', this.typeId);
            formData.append('outgoing_student_id', studentId);
            formData.append('outgoing_term_id', termId);
            formData.append('user_id', userId);
            this.dmService.javaDocumentUploadCall(formData).subscribe(response => {
                if (response.status === 'success') {
                    this.toastr.success('Successfully uploaded the file ' + file.name, 'Success');
                    this.router.navigateByUrl('/RefreshComponent', {skipLocationChange: true}).then( () =>
                        this.router.navigate(['documents']));
                } else if (response.status === 'fail') {
                    this.toastr.warning(response.message, 'Fail');
                    this.errorMessage = response.message;
                }
            }, error => {
                console.log(error);
                this.toastr.warning('Something went wrong. please contact support team', 'Fail');
                this.errorMessage = 'Server Error';
            });
        }

    }

    uploadIncomingStudentFile() {
        if (this.typeId === null || this.typeId === undefined || this.typeId === '') {
            this.toastr.warning('Please select a valid document type', 'Fail');
            return;
        }
        if (this.fileList.length === 1) {
            const studentId = JSON.parse(localStorage.getItem('epas_user')).roles[0].epas_user_role_mapping.incoming_student_id;
            const userId = JSON.parse(localStorage.getItem('epas_user')).user_id;
            const file: File = this.fileList[0];
            const formData: FormData = new FormData();
            formData.append('file', file);
            formData.append('incoming_student_id', studentId);
            formData.append('document_type_id', this.typeId);
            formData.append('user_id', userId);
            this.dmService.javaUploadIncomingStudentDocument(formData).subscribe(response => {
                if (response.status === 'success') {
                    this.toastr.success('Successfully uploaded the file ' + file.name, 'Success');
                    this.router.navigateByUrl('/RefreshComponent', {skipLocationChange: true}).then( () =>
                        this.router.navigate(['documents']));
                } else if (response.status === 'fail') {
                    this.toastr.warning(response.message, 'Fail');
                    this.errorMessage = response.message;
                }
            }, error => {
                console.log(error);
                this.toastr.warning('Something went wrong. please contact support team', 'Fail');
                this.errorMessage = 'Server Error';
            });
        }

    }

    deleteDocument(document) {
        this.dmService.javaPostDataCall(document, Constants.OUTGOING_STUDENT_FILE_DELETE).subscribe(response => {
            if (response.status === 'success') {
                this.fileList = undefined;
                this.toastr.success('Successfully deleted the file ', 'Success');
                this.router.navigateByUrl('/RefreshComponent', {skipLocationChange: true}).then( () =>
                    this.router.navigate(['documents']));
            } else if (response.status === 'fail') {
                if (response.hasOwnProperty('message')) {
                    this.toastr.warning(response.message, 'Fail');
                } else {
                    this.toastr.warning('Something went wrong. please contact support team', 'Fail');
                }
            }
        }, error => {
            console.log(error);
            this.toastr.warning('Something went wrong. please contact support team', 'Fail');
        });
    }

    deleteIncomingStudentDocument(document) {
        document.incoming_student_id = JSON.parse(localStorage.getItem('epas_user')).roles[0].epas_user_role_mapping.incoming_student_id;
        this.dmService.javaPostDataCall(document, Constants.INCOMING_STUDENT_FILE_DELETE).subscribe(response => {
            if (response.status === 'success') {
                this.fileList = undefined;
                this.toastr.success('Successfully deleted the file ', 'Success');
                this.router.navigateByUrl('/RefreshComponent', {skipLocationChange: true}).then( () =>
                    this.router.navigate(['documents']));
            } else if (response.status === 'fail') {
                if (response.hasOwnProperty('message')) {
                    this.toastr.warning(response.message, 'Fail');
                } else {
                    this.toastr.warning('Something went wrong. please contact support team', 'Fail');
                }
            }
        }, error => {
            console.log(error);
            this.toastr.warning('Something went wrong. please contact support team', 'Fail');
        });
    }

    getNextRouterLink() {
        const studentId = JSON.parse(localStorage.getItem('epas_user')).roles[0].epas_user_role_mapping.student_id;
        this.utilService.refreshTerm(studentId).subscribe(
            details => {
                if ( details.data.hasOwnProperty('rounds')) {
                    this.utilService.term = {rounds: details.data.rounds};
                    this.utilService.term.currentTime = details.data.current_time;
                    this.utilService.term.registration_start_time = details.data.term.registration_start_time;
                    this.utilService.term.registration_end_time = details.data.term.registration_end_time;
                }
                this.activeRoundLink = this.utilService.getNextActiveRoundRouterLink().split('#')[0];
                this.activeRound = this.utilService.getNextActiveRoundRouterLink().split('#')[1];

            },
            error => {
                console.log(error);
                this.toastr.warning('Something is not right. Please refresh and reach out to contact team if' +
                    ' the issue persists', 'Fail');
                // this.errorMessage = 'Server Error';
            });
        if (this.route.indexOf('/documents') === -1) {
            clearInterval(this.timer);
        }
    }

    ngOnInit() {
        this.route = this.router.url;
        this.dtOptions = {
            paging: true,
            retrieve: true,
            destroy: true,
            lengthChange: true,
            info: false
        };
        if (this.canAccessOutgoingStudent()) {
            this.getData();
            if (JSON.parse(localStorage.getItem('epas_user')) !== undefined &&
                JSON.parse(localStorage.getItem('epas_user')).term !== null &&
                JSON.parse(localStorage.getItem('epas_user')).term !== undefined) {
                this.getNextRouterLink();
                this.timer = setInterval(() => {
                    this.getNextRouterLink();
                }, 30000);
            }
        }
        if (this.canAccessIncomingStudent()) {
            this.getIncomingStudentData();
        }
    }

    ngOnDestroy(): void {
        clearInterval(this.timer);
    }

}
